import * as d3 from "d3";
export default class HeatMap {
    constructor(containerId, width, height, margins, rowNames, columnNames, color0, color1) {
        d3.select(`#${containerId}`).selectAll('*').remove();
        const margin = margins, innerWidth = width - margin.left - margin.right, innerHeight = height - margin.top - margin.bottom;
        this._color0 = color0;
        this._color1 = color1;
        this._svg = d3.select(`#${containerId}`)
            .append("svg")
            .attr("width", innerWidth + margin.left + margin.right)
            .attr("height", innerHeight + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        this._x = d3.scaleBand()
            .range([0, innerWidth])
            .domain(columnNames)
            .padding(0.05);
        const xAxisG = this._svg.append("g")
            .style("font-size", 15)
            .attr("transform", "translate(0," + innerHeight + ")")
            .call(d3.axisBottom(this._x).tickSize(0));
        xAxisG.select(".domain").remove();
        xAxisG.selectAll(".tick")
            .attr("class", "metrum-clickable faint-on-hover")
            .on("mouseover", (event, d) => {
            if (this.xTickHover) {
                this.xTickHover(d);
            }
        })
            .on("click", (event, d) => {
            if (this.xTickClick) {
                this.xTickClick(d);
            }
        });
        this._y = d3.scaleBand()
            .range([innerHeight, 0])
            .domain(rowNames)
            .padding(0.05);
        const yAxisG = this._svg.append("g")
            .style("font-size", 15)
            .call(d3.axisLeft(this._y).tickSize(0));
        yAxisG.select(".domain").remove();
        yAxisG.selectAll(".tick")
            .attr("class", "metrum-clickable faint-on-hover")
            .on("mouseover", (event, d) => {
            if (this.yTickHover) {
                this.yTickHover(d);
            }
        })
            .on("click", (event, d) => {
            if (this.yTickClick) {
                this.yTickClick(d);
            }
        });
    }
    update(data) {
        const _this = this;
        this._svg.selectAll()
            .data(data, function (d) { return d.columnName + ':' + d.rowName; })
            .enter()
            .append("rect")
            .attr("class", "metrum-clickable faint-on-hover")
            .attr("x", function (d) { return _this._x(d.columnName); })
            .attr("y", function (d) { return _this._y(d.rowName); })
            .attr("rx", 4)
            .attr("ry", 4)
            .attr("width", _this._x.bandwidth())
            .attr("height", _this._y.bandwidth())
            .style("fill", function (d) {
            if (d.value === null || isNaN(d.value))
                return "grey";
            return d3.interpolateHsl(_this._color0, _this._color1)(d.value).toString();
        })
            .style("stroke-width", 4)
            .style("stroke", "none")
            .on("mouseover", (event, d) => {
            if (_this.squareHover) {
                _this.squareHover(d.tag);
            }
        })
            .on("click", (event, d) => {
            if (_this.squareClick) {
                _this.squareClick(d.tag);
            }
        });
    }
}
